import { TargetPromotionRequest } from '../target-promotion-request';

export class LeaderboardRankingRequest extends TargetPromotionRequest {
    minRank: number;
    maxRank: number;
}
